<template>
    <form v-on:submit.prevent="submit" class="login-form d-flex flex-column border p-4 p-md-5">
        <span class="back-button mb-5">
            <div class="d-inline-block cursor-pointer" @click="handleActiveSection(REGISTER_SECTION_ONE)"><font-awesome-icon class="fa-lg" :icon="['fas', 'long-arrow-alt-left']" /> &nbsp; {{ $t('common.back') }}</div>
        </span>
        <h5>{{ $t('forms.verificationKeySent') }}</h5>
        <div class="">
            <BasicLabel :title="$t('forms.key')" :required="true" class="fw-bold" />
            <BasicInputText
                :hasRoundedCorners="true"
                class="login-input"
                :placeholder="$t('forms.verificationKey')"
                v-model="key"
            />
            <div v-if="v$.key.$errors.length" class="text-danger">
                <div class="input-errors" v-for="error of v$.key.$errors" :key="error.$uid">
                    <div class="error-msg">{{ error.$message }}</div>
                </div>
            </div>
        </div>
        <div class="login-field">
          <BasicLabel :title="$t('forms.firstName')" :required="true" class="fw-bold" />
          <BasicInputText
            :hasRoundedCorners="true"
            class="login-input"
            :placeholder="$t('forms.firstName')"
            v-model="firstName"
          />
          <div v-if="v$.firstName.$errors.length" class="text-danger">
            <div class="input-errors" v-for="error of v$.firstName.$errors" :key="error.$uid">
              <div class="error-msg">{{ error.$message }}</div>
            </div>
          </div>
        </div>
        <div class="login-field">
          <BasicLabel :title="$t('forms.lastName')" :required="true" class="fw-bold" />
          <BasicInputText
            :hasRoundedCorners="true"
            class="login-input"
            :placeholder="$t('forms.lastName')"
            v-model="lastName"
          />
          <div v-if="v$.lastName.$errors.length" class="text-danger">
            <div class="input-errors" v-for="error of v$.lastName.$errors" :key="error.$uid">
              <div class="error-msg">{{ error.$message }}</div>
            </div>
          </div>
        </div>
        <div class="login-field-last">
          <BasicLabel :title="$t('forms.password')" :required="true" class="fw-bold" />
          <BasicInputText
            :hasRoundedCorners="true"
            class="login-input"
            type="password"
            :placeholder="$t('forms.password')"
            v-model="password"
          />
          <div v-if="v$.password.$errors.length" class="text-danger">
            <div class="input-errors" v-for="error of v$.password.$errors" :key="error.$uid">
              <div class="error-msg">{{ error.$message }}</div>
            </div>
          </div>
        </div>

        <ButtonFilled
            class="mt-4 Minicart_button fw-bold text-white"
            :text="$t('common.next')"
            :hasRoundedCorners="true"
        />
    </form>
  </template>
  
  <script>
  import { useVuelidate } from '@vuelidate/core';
  import { required, maxLength, minLength } from '@vuelidate/validators';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import ButtonFilled from "../../atoms/Button/ButtonFilled.vue";
  import BasicInputText from "../../atoms/FormInput/BasicInputText.vue";
  import BasicLabel from "../../atoms/FormInput/BasicLabel.vue";
  import { createUserService, userLoginService } from '../../../services/authService';
  import { REGISTER_SECTION_ONE, REGISTER_SECTION_THREE, LOGGED_IN_USER } from '../../../constents/app';
  
  export default {
    components: {
      ButtonFilled,
      BasicInputText,
      BasicLabel,
      FontAwesomeIcon
    },
    props: {
      verificationCode: {
        type: String,
        default: ''
      },
      email: {
        type: String,
        default: ''
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        firstName: { required },
        lastName: { required },
        password: { required },
        key: { required, maxLengthValue: maxLength(6) , minLengthValue: minLength(6)}
      }
    },
    data() {
      return {
        firstName: '',
        lastName: '',
        password: '',
        key: '',
        REGISTER_SECTION_ONE,
        REGISTER_SECTION_THREE
      };
    },
    methods: {
      handleActiveSection(section){
        this.$emit("handle-active-section", section);
      },
      createUserService(data){
        return createUserService(data);
      },
      async submit() {
        this.v$.$touch();
        if (this.v$.$invalid) return;

        let userCreateRes = await this.createUserService({
            "datiUtente": {
              "name": this.firstName,
              "lastName": this.lastName,
              "password": this.password
            },
            "codice": this.key,
            "key": this.verificationCode,
            "gruppo":"Clienti"
        })

        if(userCreateRes.code == 'USER_EXIST'){
          this.$toast.error("User already exists");
          return
        }

        if(userCreateRes.code == 'CODICE_VERIFICA_ERRATO'){
          this.$toast.error("User verification failed");
          return
        }

        if(userCreateRes.code == 'UNHANDLED_ERROR'){
          this.$toast.error("Something went wrong");
          return
        }

        if(userCreateRes._id){
          const loggedIn = await this.autoLoginAfterRegister();
          if (loggedIn) {
            this.$router.push(this.$route.query.redirect || { name: 'ShopDefault' });
            return;
          }
          this.handleActiveSection(REGISTER_SECTION_THREE);
        }
      },
      async autoLoginAfterRegister() {
        try {
          const loginRes = await userLoginService({
            email: this.email,
            password: this.password,
            type: 'username_password'
          });
          if (!loginRes || !loginRes.token) return false;
          localStorage.setItem('userToken', loginRes.token);
          if (loginRes.refreshtoken) {
            localStorage.setItem('refreshtoken', loginRes.refreshtoken);
          }
          // Identity change: drop guest-owned cart/wishlist (same as FormLogin).
          localStorage.removeItem('carrelloId');
          this.$store.commit('resetCart');
          this.$store.commit('wishlist/resetWishlist');
          this.$store.dispatch('user/updateLoggedInUserType', LOGGED_IN_USER);
          return true;
        } catch (_) {
          return false;
        }
      }
    }
  };
  </script>
  <style scoped="scoped">
  .back-button{
    color: var(--primary-color) !important;
    font-weight: bold;
    font-size: 16px;
  }
  .customer-checkbox {
    margin-top: 10px;
  }
  .login-input {
    height: 40px !important;
    padding: 10px 20px !important;
    box-shadow: none !important;
    margin-top: 10px;
  }
  .form-check {
    padding-left: 27px !important;
  }
  .login-field,
  .login-field-last {
    margin-top: 30px !important;
  }
  
  .Minicart_button {
    width: 150px !important;
    height: 40px !important;
  }
  @media screen and (max-width: 768px) {
    .login-input {
      width: 100% !important;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .login-input {
      width: 250px !important;
    }
    .form-check-input input {
      width: 15px !important;
    }
  }
  </style>
  